<template>
  <div class="white-container full-page-container common-table pupup-page">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <div ref="tableBox" class="activity-table">
      <tableList ref="multipleTable" size="small" :query-function="$Api.popup.fetchList" style="width: 100%">
        <el-table-column prop="id" label="弹窗ID" />
        <el-table-column prop="popUpType" label="弹窗分类">
          <template v-slot="{row}">
            <div class="activity-type activity-type-common">{{ popupType[row.popUpType].value || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="popUpName" label="弹窗名称" />
        <el-table-column prop="status" label="弹窗状态" width="110">
          <template v-slot="{row}">
            <el-tag :type="popupStatus[row.status].color" size="mini">{{ popupStatus[row.status].value || '--' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="beginTime" label="弹窗开始时间" width="140">
          <template v-slot="{row}">
            <span>{{ formatTime(row.beginTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="250px" label="操作">
          <template v-slot="{row}">
            <el-button size="small" type="text" class="link-color" @click="edit(row.id)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="remove(row.id)">删除</el-button>
            <el-button v-if="row.status === 0" size="small" type="text" class="link-color" @click="up(row.id)">发布</el-button>
            <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="down(row.id)">下架</el-button>
          </template>
        </el-table-column>
      </tableList>
      <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
export default {
  components: { tableList, Dialog },
  data() {
    const popupStatus = [
      { id: 0, value: '草稿', color: 'warning' },
      { id: 1, value: '发布', color: 'success' },
      { id: 2, value: '已结束', color: 'info' },
    ];
    const popupType = [
      { value: 'CRM' },
      { value: 'Campaign' },
      { value: 'What’ s New' },
    ];
    return {
      popupStatus,
      popupType,
      formDialogShow: false,
      currentID: -1,
      information: {},
    };
  },
  methods: {
    formatTime(time) {
      if (!time) return '--';
      return this.$moment(time).format('YYYY/MM/DD');
    },
    add() {
      this.$router.push({ path: '/AIOminiApp-config/AIpopup/add' });
    },
    edit(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑弹窗ID为“${id}”的数据项？`,
      };
    },
    remove(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '弹窗一旦删除，不可恢复，请确认删除弹窗',
      };
    },
    up(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'up',
        icon: 'warn',
        subTitle: '发布后，该弹窗将会于设定的开始日期生效，请确认',
      };
    },
    down(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'down',
        icon: 'warn',
        subTitle: '下架后，该条弹窗将不再生效，请确认',
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.popup.del(this.currentID).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          this.$refs['multipleTable'].getTableList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/AIOminiApp-config/AIpopup/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/AIOminiApp-config/AIpopup/edit', query: { id: this.currentID } });
      } else if (operation === 'up') {
        this.postOnlinePopup(this.currentID);
      } else if (operation === 'down') {
        this.postOfflinePopup(this.currentID);
      }
    },
    // 上架弹窗
    postOnlinePopup(id) {
      this.$Api.popup.publish(id).then(() => {
        this.$message.success('上架成功');
        this.$refs['multipleTable'].getTableList();
      });
    },
    // 下架弹窗
    postOfflinePopup(id) {
      this.$Api.popup.lowerShelf(id).then(() => {
        this.$message.success('下架成功');
        this.$refs['multipleTable'].getTableList();
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
